<div class="py-4">
  <sens-subscribe-banner [type]="'search'" class="block min-[1000px]:hidden! mb-2" />

  @if (isLoading$()) {
    @if (!!query$()) {
      <p class="font-bold mb-2 text-sm/5">Searching by "{{query$()}}"</p>
    } @else {
      <p class="font-bold mb-2 text-sm/5">Searching...</p>
    }
  } @else {
    @if (!!faps$().length) {
      <p class="font-bold mb-2 text-sm/5">Founded results </p>
    } @else {
      <p class="font-bold mb-2 text-sm/5">No results by "{{query$()}}"</p>
    }
  }

  @if (!!faps$().length) {
    <sens-recycler-view [isLoading]="false" (isIntersecting)="onIntersecting($event)">
      <div class="grid grid-cols-2 min-[1000px]:grid-cols-4 gap-0.5 mb-2">
        @for (item of faps$(); track item.fap_id) {
          <a [routerLink]="['/faps', item.fap_id]"
             [analytics]="AnalyticsEventsEnum.SearchResultTap"
             [params]="{id: item.fap_id, query: query$() ?? ''}"
             class="bg-gray-500 rounded-xl overflow-hidden h-[300px] min-[1000px]:h-[265px] relative">
            <img [src]="item.preview_url" class="h-full w-full object-cover" alt="">
            <div class="h-10 absolute bottom-0 left-0 z-1 w-full
                      bg-linear-[180deg,#18181900_5%,#181819B2_60%,#181819_100%]
                      flex items-center flex-row justify-end px-3">
              <p class="flex flex-row items-center gap-1 text-white font-bold text-xs/4">
                <sens-icon [size]="16" icon="#icon-view"/>
                {{item?.views}}
              </p>
            </div>
          </a>
        }
      </div>
    </sens-recycler-view>
  }
</div>
